import 'bootstrap';
import 'tooltipster/js/jquery.tooltipster.min.js';
import Global from './modules/Global';
import Nav from './modules/Nav';
import Header from './modules/Header';
import PageChecker from './modules/Page';
import TemplateChecker from './modules/Template';
import Modal from './modules/Modal';
import SpecialOfferModal from './modules/SpecialOfferModal';
import ProfessionalListModal from "./modules/ProfessionalListModal";
import Home from './pages/Home';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import Register from './pages/Register';
import PensionDetails from './pages/PensionDetails';
import Contact from './pages/Contact';
import Resources from './pages/Resources';
import Resource from './pages/Resource';
import AboutUs from './pages/AboutUs';

window.Global = new Global;
window.Nav = new Nav;
new Header;

const Template = new TemplateChecker;
const Page = new PageChecker;

if ($('.modal').length) {
    new Modal;
}

if ($('#specialOfferModal').length) {
    new SpecialOfferModal;
}

if ($('#professionalListModal').length) {
    new ProfessionalListModal;
}

if (Template.is('home')) {
    new Home;
}

if (Page.is('features')) {
    new Features;
}

if (Page.is('pricing')) {
    new Pricing;
}

if (Page.in(['register', 'registerpersonal-details', 'registerpension-details'])) {
    new Register;
}

if (Page.is('registerpension-details')) {
    new PensionDetails;
}

if (Template.is('contact')) {
    new Contact;
}

if (Template.is('resources')) {
    new Resources;
}

if (Template.is('resource')) {
    new Resource;
}

if (Template.is('aboutus')) {
    new AboutUs;
}
